"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { isAutoGeneratedHandle, isEthereumAddress } from "@/helpers/AllowlistToolHelpers";
import { GroupCardState } from "./GroupCard";
import GroupCardConfigs from "./GroupCardConfigs";
export default function GroupCardContent(t0) {
  const $ = _c(20);
  const {
    group,
    haveActiveGroupVoteAll,
    setState,
    titlePlaceholder
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const groupName = group?.name ?? titlePlaceholder ?? "";
  const nameHref = group ? `/network?page=1&group=${group.id}` : undefined;
  const containsAddress = groupName.split(/\s+/).some(_temp);
  const nameClasses = containsAddress ? "tw-block tw-mb-0 tw-max-w-full tw-truncate tw-text-lg tw-font-semibold tw-leading-tight tw-text-iron-50" : "tw-block tw-mb-0 tw-max-w-full tw-line-clamp-2 tw-text-lg tw-font-semibold tw-leading-tight tw-text-iron-50";
  let t1;
  if ($[0] !== groupName || $[1] !== nameClasses || $[2] !== nameHref || $[3] !== setState) {
    t1 = nameHref ? <a href={nameHref} onClick={event => {
      event.preventDefault();
      event.stopPropagation();
      setState?.(GroupCardState.IDLE);
    }} className={`${nameClasses} tw-no-underline tw-transition tw-duration-200 tw-ease-out desktop-hover:hover:tw-text-iron-300`} title={groupName}>{groupName}</a> : <span className={nameClasses} title={groupName}>{groupName}</span>;
    $[0] = groupName;
    $[1] = nameClasses;
    $[2] = nameHref;
    $[3] = setState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="tw-mt-1 tw-text-xs tw-text-iron-400">Source: filters + optional manual list</p>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = <div className="tw-min-w-0 tw-flex-1">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== connectedProfile?.handle || $[9] !== haveActiveGroupVoteAll || $[10] !== setState) {
    t4 = !!connectedProfile?.handle && setState && <div className="tw-flex tw-flex-shrink-0 tw-flex-wrap tw-items-center tw-justify-end tw-gap-2"><button type="button" disabled={haveActiveGroupVoteAll} className={`${"tw-relative tw-z-30 tw-inline-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-lg tw-border tw-border-solid tw-ring-1 tw-ring-iron-700 tw-font-semibold tw-shadow-sm tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700"} ${"tw-px-2.5 tw-py-1.5 tw-text-sm"} ${haveActiveGroupVoteAll ? "tw-bg-iron-900 tw-border-iron-900 tw-text-iron-500 tw-cursor-not-allowed tw-opacity-50" : "tw-bg-iron-800 tw-border-iron-800 tw-text-iron-200 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-text-white"}`} onClick={event_0 => {
        event_0.stopPropagation();
        setState(GroupCardState.REP);
      }}>Rep all</button><button type="button" disabled={haveActiveGroupVoteAll} className={`${"tw-relative tw-z-30 tw-inline-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-lg tw-border tw-border-solid tw-ring-1 tw-ring-iron-700 tw-font-semibold tw-shadow-sm tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700"} ${"tw-px-2.5 tw-py-1.5 tw-text-sm"} ${haveActiveGroupVoteAll ? "tw-bg-iron-900 tw-border-iron-900 tw-text-iron-500 tw-cursor-not-allowed tw-opacity-50" : "tw-bg-iron-800 tw-border-iron-800 tw-text-iron-200 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-text-white"}`} onClick={event_1 => {
        event_1.stopPropagation();
        setState(GroupCardState.NIC);
      }}>NIC all</button></div>;
    $[8] = connectedProfile?.handle;
    $[9] = haveActiveGroupVoteAll;
    $[10] = setState;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-4 tw-gap-y-2">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== group) {
    t6 = <GroupCardConfigs group={group} />;
    $[15] = group;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-y-3">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(token) {
  return isEthereumAddress(token) || isAutoGeneratedHandle(token);
}